import {
  SeoSidebarForm,
  SeoSidebarHeader,
  SeoSidebarMenu,
} from '@components/ArtBoard/SeoModeSidebar/components'
import { Panel } from '@lib/components'
import { ThemeColors } from '@octopus-do/octopus-storybook'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { seoPanelHide } from '@storeOld/reducers/ui'
import { selectSeoPanelState } from '@storeOld/selectors'
import type React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

export const SeoModeSidebar: React.FC = () => {
  const dispatch = useDispatch()

  const showSeoNodeId = useSelector(selectSeoPanelState)

  if (!showSeoNodeId) {
    return null
  }

  const node = useSelector(
    migrationProjectSelector.getProjectNodeById(showSeoNodeId)
  )

  const colorHex = useSelector(
    migrationProjectSelector.getProjectColorForUI(node.colorId)
  )

  const handleOnClose = () => {
    dispatch(seoPanelHide())
  }

  return (
    <Panel
      title={
        <SeoSidebarHeader
          title={node.title}
          colorHex={colorHex}
          variant={node.variant}
        />
      }
      containerClassName={clsJoin(css.seo_sidebar, ThemeColors.light)}
      additionalHeaderActions={<SeoSidebarMenu nodeId={showSeoNodeId} />}
      onClose={handleOnClose}
    >
      <SeoSidebarForm nodeId={showSeoNodeId} />
    </Panel>
  )
}
